import { getLinkImageStatic, getLinkImageStaticWebHost } from 'utils/CacheImageUtils';
import { GCS_IMAGE, WEB_HOST } from 'sysconfig';

export const DUREX_INFO = {
  primaryColor: '#025BAC',
  secondaryColor: '#D0E7FF',
  titleColor: '#025BAC',
  backgroundColor: '#E9F3FE',
  borderAvatarColor: '#2D9CDB',
  url: `${WEB_HOST}/flagship-store/durex`,
  backgrounds: [`${GCS_IMAGE}/thuocsi-testing/images/2022f79adf10d22789d52c674d398e40`],
  thumbnail: [getLinkImageStatic(`/images/flagship-store/durex/home/thumbnail.png`)],
  banners: [
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [
        getLinkImageStatic(
          `/images/flagship-store/durex/home/sliding-banner-promotion-13_9_2022.png`,
        ),
      ],
      isActive: true,
      link: 'https://bit.ly/durex-store-banner',
      name: 'Gian hàng DUREX chính hãng',
      type: 'SLIDER',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/home/sliding-banner-1.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'SLIDER',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/home/sliding-banner-2.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'SLIDER',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/home/sliding-banner-4.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'SLIDER',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/home/sliding-banner-5.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'SLIDER',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/home/sliding-banner-6.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'SLIDER',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/home/banner.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'BANNER_CONTENT',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/product/product-banner-0.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'BANNER_PRODUCT',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/product/product-banner-1.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'BANNER_PRODUCT',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/product/product-banner-2.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'BANNER_PRODUCT',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/product/product-banner-3.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'BANNER_PRODUCT',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/product/product-banner-4.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'BANNER_PRODUCT',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/product/product-banner-5.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'BANNER_PRODUCT',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/product/product-banner-6.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'BANNER_PRODUCT',
    },
    {
      description:
        'Hãy lựa chọn mua Durex chính hãng tại thuocsi.vn để có những sản phẩm an toàn và chất lượng.',
      hashTag: 'durex',
      images: [getLinkImageStatic(`/images/flagship-store/durex/product/product-banner-7.png`)],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/durex/list-product`,
      name: 'Gian hàng DUREX chính hãng',
      type: 'BANNER_PRODUCT',
    },
  ],
  description: `<p>Bao Cao Su là sản phẩm được lựa chọn nhiều nhất để phòng tránh thai, trong đó kênh nhà thuốc chiếm vai trò rất quan trọng đối với việc phân phối sản phẩm tới người tiêu dùng. Durex là thương hiệu bao cao su số 1 thế giới và Việt Nam. Hãy lựa chọn mua Durex chính hãng tại <a target="_blank" href="http://thuocsi.vn">http://thuocsi.vn</a> để có những sản phẩm an toàn và chất lượng.</p>
	`,
  email: 'durex@thuocsi.vn',
  feedbacks: [
    {
      avatar: [getLinkImageStatic(`/images/flagship-store/durex/customer/customer1.png`)],
      content:
        'thuocsi có đầy đủ mặt hàng của Durex nên mỗi lần lên đơn cùng một chỗ rất tiện, giá sỉ dù mua lẻ.',
      customerName: 'Chị Mai',
    },
    {
      avatar: [getLinkImageStatic(`/images/flagship-store/durex/customer/customer2.png`)],
      content: 'Hàng chính hãng, mua rất an tâm.',
      customerName: 'Chị Lan Anh',
    },
    {
      avatar: [getLinkImageStatic(`/images/flagship-store/durex/customer/customer3.png`)],
      content: 'Giao hàng đủ khi đặt hàng.',
      customerName: 'Anh Tuấn Văn',
    },
  ],
  landingPages: [],
  logo: [getLinkImageStatic(`/images/flagship-store/durex/logo.png`)],
  name: 'Gian hàng DUREX chính hãng',
  numberProductDisplay: 0,
  numberProducts: 0,
  sellerClass: 'EXTERNAL',
  slug: 'durex',
  status: 'ACTIVE',
  storeType: 'FLAGSHIP',
  videoIntroduces: ['https://www.youtube.com/watch?v=AVPOa6lyv_0'],
  tags: [
    {
      code: 'DUREX-HERO',
      type: 'fav',
      backgroundTitleColor: 'transparent',
      titleColor: '#025BAC',
      backgroundColor: '#D0E7FF',
    },
    {
      code: 'DUREX',
      type: 'new',
      backgroundTitleColor: '#025BAC',
      titleColor: '#fff',
      backgroundColor: '#fff',
    },
    {
      code: 'DUREX-CAT1',
      type: 'new',
      backgroundTitleColor: '#025BAC',
      titleColor: '#fff',
      backgroundColor: '#fff',
    },
    {
      code: 'DUREX-CAT2',
      type: 'new',
      backgroundTitleColor: '#025BAC',
      titleColor: '#fff',
      backgroundColor: '#fff',
    },
  ],
};

export const SANOFI_INFO = {
  primaryColor: '#7404E0',
  secondaryColor: '#EEE9FE',
  titleColor: '#7404E0',
  backgroundColor: '#EEE9FE',
  borderAvatarColor: '#7404E0',
  backgrounds: [`${GCS_IMAGE}/thuocsi-testing/images/2022f79adf10d22789d52c674d398e40`],
  url: `${WEB_HOST}/flagship-store/sanofi`,
  banners: [
    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/home/sliding-banner-1_5-8-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/sanofi/list-product`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'SLIDER',
    },
    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/home/sliding-banner-2_5-8-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/sanofi/list-product`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'SLIDER',
    },
    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/home/sliding-banner-5_5-8-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/sanofi/list-product`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'SLIDER',
    },
    // {
    //   description: 'Sanofi',
    //   hashTag: 'sanofi',
    //   images: [getLinkImageStatic(`/images/flagship-store/sanofi/home/sliding-banner-3_15-9-2022.png`)],
    //   isActive: true,
    //   link: `${WEB_HOST}/products?tag=SANOFI-CAT3`,
    //   name: 'Gian hàng SANOFI chính hãng',
    //   type: 'SLIDER',
    // },
    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/home/sliding-banner-4_15-9-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/products?tag=SANOFI-CAT4`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'SLIDER',
    },
    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/home/sliding-banner-3_15-9-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/products?tag=SANOFI-CAT3`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'SLIDER',
    },
    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/product/product-banner-1_5-8-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/sanofi/list-product`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'BANNER_PRODUCT',
    },
    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/product/product-banner-2_5-8-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/sanofi/list-product`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'BANNER_PRODUCT',
    },
    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/product/product-banner-5_5-8-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/flagship-store/sanofi/list-product`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'BANNER_PRODUCT',
    },

    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/product/product-banner-4_15-9-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/products?tag=SANOFI-CAT4`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'BANNER_PRODUCT',
    },

    {
      description: 'Sanofi',
      hashTag: 'sanofi',
      images: [
        getLinkImageStaticWebHost(
          `/images/flagship-store/sanofi/product/product-banner-3_15-9-2022.png`,
        ),
      ],
      isActive: true,
      link: `${WEB_HOST}/products?tag=SANOFI-CAT3`,
      name: 'Gian hàng SANOFI chính hãng',
      type: 'BANNER_PRODUCT',
    },
  ],
  description: `<p>Sanofi là tập đoàn chăm sóc sức khỏe hàng đầu thế giới, luôn cam kết hỗ trợ chăm sóc và cải thiện chất lượng sức khỏe của bệnh nhân. Từ phòng ngừa đến điều trị, Sanofi đã dựa trên những thành tựu nghiên cứu khoa học để đưa đến những giải pháp chăm sóc sức khỏe con người, như vắc-xin, thuốc trị bệnh hiếm gặp, bệnh đa xơ cứng, ung thư, các bệnh liên quan đến miễn dịch, bệnh truyền nhiễm, tiểu đường, các giải pháp cho tim mạch cũng như chăm sóc sức khỏe người tiêu dùng. Hơn 100.000 nhân viên của Sanofi làm việc tại 100 quốc gia đang nỗ lực để tạo nên sự khác biệt cho đời sống bệnh nhân ở bất cứ nơi nào họ sống và cho phép họ tận hưởng một cuộc sống lành mạnh hơn.</p>`,
  email: 'sanofi@thuocsi.vn',
  feedbacks: [
    {
      avatar: [getLinkImageStaticWebHost(`/images/flagship-store/sanofi/customer/customer1.png`)],
      content:
        'Lượng mặt hàng đa dạng được liệt kê rõ ràng, tôi có thể dễ dàng tìm kiếm được những sản phẩm mà tôi cần.',
      customerName: 'Chị Hoàng Ngân',
    },
    {
      avatar: [getLinkImageStaticWebHost(`/images/flagship-store/sanofi/customer/customer2.png`)],
      content:
        'Giá các sản phẩm luôn bình ổn cũng như có nhiều chương trình khuyến mãi, quà tặng và ưu đãi trong tháng.',
      customerName: 'Anh Tuấn Anh',
    },
    {
      avatar: [getLinkImageStaticWebHost(`/images/flagship-store/sanofi/customer/customer3.png`)],
      content:
        'Hàng hóa đóng gói cẩn thận, kĩ càng cũng như tư vấn về các sản phẩm rất nhiệt tình và rõ ràng.',
      customerName: 'Anh Duy Hà',
    },
  ],
  landingPages: [],
  logo: [getLinkImageStaticWebHost(`/images/flagship-store/sanofi/logo.png`)],
  name: 'Gian hàng SANOFI chính hãng',
  numberProductDisplay: 0,
  numberProducts: 0,
  sellerClass: 'EXTERNAL',
  slug: 'sanofi',
  status: 'ACTIVE',
  storeType: 'FLAGSHIP',
  videoIntroduces: ['https://www.youtube.com/watch?v=ssY36cNs2SA&ab_channel=TPBVSKPharmaton'],
  tags: [
    // {
    //   code: 'SANOFI-HERO',
    //   type: 'fav',
    //   backgroundColor: '#1E034A',
    //   backgroundTitleColor: 'transparent',
    //   titleColor: '#fff',
    // },
    {
      code: 'SANOFI',
      type: 'deal',
      backgroundColor: '#1E034A',
      backgroundTitleColor: 'transparent',
      titleColor: '#fff',
    },
    // {
    //   code: 'SANOFI-CAT1',
    //   type: 'new',
    //   backgroundColor: '#1E034A',
    //   backgroundTitleColor: 'transparent',
    //   titleColor: '#fff',
    // },
    {
      code: 'SANOFI-CAT2',
      type: 'new',
      backgroundColor: '#0A71CE',
      titleColor: '#fff',
      titleBanner: getLinkImageStaticWebHost(
        `/images/flagship-store/sanofi/product/categoryBannerTitle/Duongruot.png`,
      ),
      bannerHeight: 81,
      priority: [
        'medx-enterogermina-4-billion5ml-sanofi-hop20ong5ml',
        'medx-enterogermina-2-billion5ml-sanofi-hop20ong5ml',
        'medx-phosphalugel-sanofi-hop26goi20gram',
        'medx-mepraz-omeprazol-20mg-sanofi-hop28-vien-nang',
      ],
    },
    {
      code: 'SANOFI-CAT3',
      type: 'new',
      backgroundColor: '#EF8C21',
      titleColor: '#fff',
      titleBanner: getLinkImageStaticWebHost(
        `/images/flagship-store/sanofi/product/categoryBannerTitle/Thuocxuongkhop.png`,
      ),
      bannerHeight: 73,
      priority: [
        'medx-bo-sung-vitamin-va-khoang-chat-pharmaton-energy-rottendorf-chai30-vien-nen',
        'medx-bo-sung-vitamin-va-khoang-chat-pharmaton-essential-biofarma-srl-chai30-vien-nen',
        'medx-calcium-corbiere-extra-sanofi-hop30ong10ml',
        'medx-calcium-corbiere-kids-extra-hop30ong5ml',
      ],
    },
    {
      code: 'SANOFI-CAT4',
      type: 'new',
      backgroundColor: '#AC3786',
      titleColor: '#fff',
      titleBanner: getLinkImageStaticWebHost(
        `/images/flagship-store/sanofi/product/categoryBannerTitle/Thuocho-Diung.png`,
      ),
      bannerHeight: 120,
      priority: [
        'medx-telfast-hd-fexofenadin-180mg-sanofi-hop10-vien-nen',
        'medx-telfast-bd-fexofenadin-60mg-sanofi-hop10-vien-nen',
        'medx-telfast-kids-fexofenadin-30mg-sanofi-hop10-vien-nen',
        'medx-bisolvon-kids-bromhexin-4mg5ml-sanofi-chai60ml',
        'medx-acemuc-acetylcysein-100mg-sanofi-hop30goi0.5gram',
        'medx-acemuc-acetylcystein-200mg-sanofi-hop30goi1gram',
      ],
    },
    // {
    //   code: 'SANOFI-CAT5',
    //   type: 'new',
    //   backgroundColor: '#EE2375',
    //   titleColor: '#fff',
    //   titleBanner: WEB_HOST+WEB_HOST+'/images/flagship-store/sanofi/product/categoryBannerTitle/Lactacyd.png',
    //   bannerHeight: 120,
    // },
  ],
};

export const DUREX_SELLER_INFO = {
  code: 'durex-hardcode-unique-id',
  name: DUREX_INFO.name,
  product: {
    topProducts: [],
  },
  sellerStore: {
    ...DUREX_INFO,
  },
  slug: DUREX_INFO.slug,
  sellerType: 'FLAGSHIP',
  isVip: true,
  favTag: 'DUREX-HERO',
};

export const SANOFI_SELLER_INFO = {
  code: 'sanofi-hardcode-unique-id',
  name: SANOFI_INFO.name,
  product: {
    topProducts: [],
  },
  sellerStore: {
    ...SANOFI_INFO,
  },
  slug: SANOFI_INFO.slug,
  sellerType: 'FLAGSHIP',
  isVip: true,
  favTag: 'SANOFI-HERO',
};

export const MapFlagshipStoreBySlug = {
  durex: DUREX_INFO,
  sanofi: SANOFI_INFO,
  DUREX: DUREX_INFO,
  SANOFI: SANOFI_INFO,
};

export const FLAGSHIP_STORE_SLUGS = ['durex', 'sanofi'];
export const FLAGSHIP_STORE_TAGS = ['DUREX', 'SANOFI'];

export const TITLE_IMAGE_RESPONSIVE_STEP = [350, 750];

export const getHardcodeStoreByTagList = (tags) => {
  if (tags?.length) {
    // eslint-disable-next-line no-restricted-syntax
    for (const tag of tags) {
      // eslint-disable-next-line no-restricted-syntax
      for (const flagshipStoreTag of FLAGSHIP_STORE_TAGS) {
        if (tag.includes(flagshipStoreTag)) {
          return MapFlagshipStoreBySlug[flagshipStoreTag];
        }
      }
    }
  }
  return null;
};
